import React, { useState, useEffect, useRef } from "react";
import ReactModal from "react-modal";
import Scrollbar from "react-scrollbars-custom";
import Checkbox from "@material-ui/core/Checkbox";
import CheckListBox from "../Common/CheckListBox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { timeout } from "../../helpers/utilities";
import {
  fetchNewChatSearch,
  fetchSubjects,
  fetchDeps,
  fetchClasses,
  createGroup,
} from "./../../api/chatApi";
import { ListItemSecondaryAction } from "@material-ui/core";

import Select from "react-select";
import makeAnimated from "react-select/animated";

import { DebounceInput } from "react-debounce-input";
import { roleNames } from "../../helpers/roleNames";
import i18n from "../../i18n";

function ChoosePersonsModal({ closeModal, user }) {
  let searchResultScrollbar = useRef(null);

  const [groupChat, setGroupChat] = useState(false);
  const toggleGroupChat = () => {
    setGroupChat(!groupChat);
    if (showOptions) setShowOptions(false);
  };

  const [groupChatFinishStep, setGroupChatStep] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [activeTabFilter, setActiveTabFilter] = useState(0);

  const [chatGroups, setChatGroups] = useState([
    {
      id: 0,
      label: i18n.t("teachers"),
      checked: false,
      list: [],
      i18key: "choose.teachers.by.subjects",
    },
    {
      id: 1,
      label: i18n.t("cathedras"),
      checked: false,
      list: [],
      i18key: "choose.departments",
    },
    {
      id: 2,
      label: i18n.t("tutors"),
      checked: false,
      list: [],
    },
    {
      id: 3,
      label: i18n.t("students"),
      checked: false,
      list: [],
      i18key: "choose.pupils.by.classes",
    },
    {
      id: 4,
      label: i18n.t("parents"),
      checked: false,
      list: [],
      i18key: "choose.parent.by.classes",
    },
    {
      id: 5,
      label: i18n.t("headof.cathedra"),
      checked: false,
      list: [],
    },
    {
      id: 6,
      label: i18n.t("admins"),
      checked: false,
      list: [],
    },
  ]);

  const moveToStartStep = () => {
    if (showOptions) setShowOptions(false);
    else setGroupChatStep(false);
  };
  const [filteredText, setFilteredText] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const [isPersonsLoading, setIsPersonsLoading] = useState(false);
  const [prevPosition, setPrevPosition] = useState(0);
  const [loadMore, setLoadMore] = useState(true);

  const filterSearchResults = async (withMore) => {
    try {
      setIsPersonsLoading(true);
      let skip = withMore ? searchResult.length : 0;
      let res = await fetchNewChatSearch({
        filter: filteredText,
        skip: skip,
        isTeacher: chatGroups[0].checked,
        isTutor: chatGroups[2].checked,
        isPupil: chatGroups[3].checked,
        isParent: chatGroups[4].checked,
        isDepManager: chatGroups[5].checked,
        isAdministrator: chatGroups[6].checked,
        teacherSubjects: chatGroups[0].list,
        pupilClasses: chatGroups[3].list,
        parentClasses: chatGroups[4].list,
        depIds: chatGroups[1].list,
      });
      if (withMore) {
        setSearchResult([...searchResult, ...res]);
        setLoadMore(res.length > 0);
        await timeout(20);
        searchResultScrollbar.current.scrollTo(0, prevPosition + 10);
      } else {
        setSearchResult(res);
        setLoadMore(true);
      }
      setIsPersonsLoading(false);
    } catch (exception) {
      setIsPersonsLoading(false);
    }
  };

  useEffect(() => {
    filterSearchResults();
  }, [filteredText, chatGroups]);

  const toggleChatGroupChecked = (id, checked, list = []) => {
    let newgroup = [...chatGroups];
    let item = newgroup.find((g) => g.id === id);
    item.checked = checked;
    item.list = list;
    setChatGroups(newgroup);
  };

  const [optionsList, setOptionsList] = useState([]);
  const handleFilterChange = async (id, checked) => {
    setActiveTabFilter(id);
    toggleChatGroupChecked(id, checked);
    if (!checked) {
      setShowOptions(false);
      return;
    }
    switch (id) {
      case 0:
        const subjects = await fetchSubjects();
        const list1 = subjects.map((i) => ({
          value: i.subjectId,
          label: i.subjectName,
        }));
        setOptionsList(list1);
        setShowOptions(true);
        break;
      case 1:
        const deps = await fetchDeps();
        const list2 = deps.map((i) => ({
          value: i.depId,
          label: i.depName,
        }));
        setOptionsList(list2);
        setShowOptions(true);
        break;
      case 3:
      case 4:
        const classes = await fetchClasses();
        let list3 = [];
        let level = {};
        classes.forEach((i) => {
          if (i.classId > 0) {
            let qitem = {
              value: i.classId,
              label: i.className,
            };
            level.options.push(qitem);
          } else {
            level = {
              options: [],
              label: i.className,
            };
            list3.push(level);
          }
        });
        setOptionsList(list3);
        setShowOptions(true);
        break;
      default:
        setShowOptions(false);
        break;
    }
  };

  const onUpdateContactListScrollbar = () => {
    if (
      searchResultScrollbar.current.scrollValues.clientHeight +
        searchResultScrollbar.current.scrollValues.scrollTop ===
      searchResultScrollbar.current.scrollValues.contentScrollHeight
    ) {
      if (!isPersonsLoading && loadMore) {
        setPrevPosition(searchResultScrollbar.current.scrollValues.scrollTop);
        filterSearchResults(true);
      }
    }
  };

  const [checkedAllPerson, setCheckedAllPerson] = useState(false);
  const [checkedPersons, setCheckedPersons] = useState([]);
  const [groupName, setGroupName] = useState("");

  const moveToFinish = () => {
    if (
      (checkedAllPerson && searchResult && searchResult.length > 1) ||
      (checkedPersons && checkedPersons.length > 1)
    ) {
      setGroupChatStep(true);
    }
  };

  const clearOptions = () => {
    toggleChatGroupChecked(activeTabFilter, false, []);
    setShowOptions(false);
  };

  const checkAllPerson = (checked) => {
    if (!checked) {
      setCheckedPersons([]);
    }
    setCheckedAllPerson(checked);
  };

  const checkPerson = (item, checked) => {
    const id = item.id;
    if (!groupChat) {
      closeModal(item, false);
      return;
    }

    if (!checked) {
      if (checkedAllPerson) return;
      setCheckedPersons(checkedPersons.filter((c) => c !== id));
    } else {
      setCheckedPersons([...checkedPersons, id]);
    }
  };

  useEffect(() => {
    setCheckedPersons([]);
    setCheckedAllPerson(false);
  }, [chatGroups]);

  useEffect(() => {
    if (!groupChat) {
      setCheckedPersons([]);
      setCheckedAllPerson(false);
    }
  }, [groupChat]);

  const createGroupAndStart = async () => {
    if (groupName) {
      let prms = {
        groupName: groupName,
        groupPersonIds: checkedPersons,
        checkedAll: checkedAllPerson,
        filterParams: {
          filter: filteredText,
          isTeacher: chatGroups[0].checked,
          isTutor: chatGroups[2].checked,
          isPupil: chatGroups[3].checked,
          isParent: chatGroups[4].checked,
          isDepManager: chatGroups[5].checked,
          isAdministrator: chatGroups[6].checked,
          teacherSubjects: chatGroups[0].list,
          pupilClasses: chatGroups[3].list,
          parentClasses: chatGroups[4].list,
          depIds: chatGroups[1].list,
        },
      };
      let id = await createGroup(prms);
      closeModal({ id, name: groupName }, true);
    }
  };

  const groupKeyAction = (e) => {
    if (e.keyCode === 13 && groupName) {
      createGroupAndStart();
    }
  };

  let chooseText = i18n.t("choose");
  let continueText = i18n.t("continue");

  const animatedComponents = makeAnimated();

  const optionsChangedHandler = (list) => {
    if (!list) list = [];
    toggleChatGroupChecked(
      activeTabFilter,
      true,
      list.map((l) => l.value)
    );
    //console.log(list);
  };

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={closeModal}
      contentLabel="Example Modal"
      className="newChatModal"
      shouldCloseOnEsc={false}
    >
      <div
        className="modal modal-lg-fullscreen fade show"
        id="startConversation"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-dialog-zoom">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{i18n.t("new.message")}</h5>
              <button
                type="button"
                className="close"
                onClick={() => closeModal()}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="row">
                {!groupChatFinishStep && (
                  <>
                    <div className="col-12">
                      <div
                        className="form-inline w-100 p-2 border-bottom start-newchat-form"
                        style={{ paddingBottom: "0 !important" }}
                      >
                        <div className="input-group w-100 bg-light ">
                          <DebounceInput
                            minLength={3}
                            debounceTimeout={1000}
                            placeholder={i18n.t("search")}
                            className="form-control form-control-md search border-right-0 transparent-bg pr-0"
                            value={filteredText}
                            onChange={(e) => setFilteredText(e.target.value)}
                          />
                          <div className="input-group-append">
                            <div
                              className="input-group-text transparent-bg border-left-0"
                              role="button"
                            >
                              <svg
                                className="hw-20"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                        {user.roles.some((r) => r > 1) && (
                          <div
                            className={
                              groupChat
                                ? "group-chat-btn active"
                                : "group-chat-btn"
                            }
                            onClick={toggleGroupChat}
                            title={i18n.t("create.group.chat")}
                          >
                            <span className="material-icons">groups</span>
                          </div>
                        )}

                        {groupChat && (
                          <>
                            <div className="group-list">
                              <Scrollbar>
                                <div className="d-flex">
                                  {chatGroups &&
                                    chatGroups
                                      .filter(
                                        (c) => !user.onlyChildren || c.id !== 4
                                      )
                                      .map((item) => (
                                        <div
                                          className={`group-item${
                                            (showOptions &&
                                              activeTabFilter === item.id) ||
                                            item.checked
                                              ? " active"
                                              : ""
                                          }`}
                                        >
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={item.checked}
                                                onChange={(e) =>
                                                  handleFilterChange(
                                                    item.id,
                                                    e.target.checked
                                                  )
                                                }
                                                name={item.label}
                                              />
                                            }
                                            label={item.label}
                                          />
                                        </div>
                                      ))}
                                </div>
                              </Scrollbar>
                            </div>
                            {showOptions && (
                              <div className="form-group w-100 multi-select-item">
                                <Select
                                  closeMenuOnSelect={true}
                                  components={animatedComponents}
                                  value={optionsList
                                    .reduce(
                                      (r, item) =>
                                        item.options
                                          ? [...r, ...item.options]
                                          : [...r, item],
                                      []
                                    )
                                    .filter((obj) =>
                                      chatGroups[activeTabFilter].list.includes(
                                        obj.value
                                      )
                                    )}
                                  className="sb-select-wrapper"
                                  classNamePrefix="sb-select"
                                  isMulti
                                  onChange={optionsChangedHandler}
                                  options={optionsList}
                                  placeholder={i18n.t(
                                    chatGroups[activeTabFilter].i18key
                                  )}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <>
                        {groupChat && searchResult && searchResult.length > 0 && (
                          <div
                            style={{
                              float: "right",
                              marginRight: "35px",
                              marginTop: "10px",
                              marginBottom: "6px",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkedAllPerson}
                                  onChange={(e) =>
                                    checkAllPerson(e.target.checked)
                                  }
                                  name="chellall"
                                />
                              }
                              label={i18n.t("select.all")}
                            />
                          </div>
                        )}
                        <ul
                          className={
                            !groupChat
                              ? "list-group list-group-flush isIndividualChat"
                              : "list-group list-group-flush group-mode-active"
                          }
                        >
                          <Scrollbar
                            style={{ height: "calc(100vh - 300px)" }}
                            onUpdate={() => onUpdateContactListScrollbar()}
                            ref={searchResultScrollbar}
                          >
                            {searchResult &&
                              searchResult.map((item) => (
                                <li
                                  className="list-group-item"
                                  style={
                                    !groupChat ? { cursor: "pointer" } : {}
                                  }
                                  key={item.id}
                                  onClick={() => {
                                    if (!groupChat) checkPerson(item);
                                  }}
                                >
                                  <div className="media">
                                    <div className="avatar avatar-offline mr-2">
                                      <img src={item.avatar} alt="" />
                                    </div>

                                    <div className="media-body">
                                      <div className="main-info">
                                        <h6 className="text-truncate">
                                          <div className="text-reset">
                                            {item.fullName}
                                          </div>
                                        </h6>

                                        <p className="text-muted mb-0">
                                          {item.roles.length > 0 &&
                                            item.roles.reduce(
                                              (s, r) =>
                                                s + `${i18n.t(roleNames[r])},`,
                                              ""
                                            )}
                                        </p>
                                      </div>
                                      <div className="other-info">
                                        <div className="text-connections">
                                          {item.attributes.length > 0 &&
                                            item.attributes.reduce(
                                              (s, r) => s + `,${r}`
                                            )}
                                        </div>
                                        {groupChat && (
                                          <div className="check-user">
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={
                                                    checkedAllPerson ||
                                                    checkedPersons.includes(
                                                      item.id
                                                    )
                                                  }
                                                  onChange={(e) =>
                                                    checkPerson(
                                                      item,
                                                      e.target.checked
                                                    )
                                                  }
                                                  name={i18n.t("admins")}
                                                />
                                              }
                                              label=""
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            {(!searchResult || !searchResult.length) &&
                              !isPersonsLoading && (
                                <div className="no-data-found">
                                  <span className="material-icons">
                                    warning
                                  </span>
                                  <h4>{i18n.t("data.not.found")}</h4>
                                </div>
                              )}
                          </Scrollbar>
                        </ul>
                      </>
                    </div>
                  </>
                )}

                {groupChatFinishStep && (
                  <div className="col-12">
                    <div className="form-group set-group-name">
                      <label for="groupName">{i18n.t("group.name")}</label>
                      <input
                        type="text"
                        className="form-control form-control-md"
                        id="groupName"
                        autoFocus
                        value={groupName}
                        onKeyUp={(e) => groupKeyAction(e)}
                        onChange={(e) => setGroupName(e.target.value)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {groupChat && (
              <div className="modal-footer">
                {groupChatFinishStep && (
                  <>
                    <button
                      type="button"
                      className="btn btn-link text-muted   mr-auto"
                      onClick={moveToStartStep}
                    >
                      {i18n.t("cancel")}
                    </button>
                  </>
                )}
                {!groupChatFinishStep && (
                  <button
                    type="button"
                    className="btn btn-primary js-btn-step"
                    onClick={moveToFinish}
                  >
                    {continueText}
                  </button>
                )}
                {groupChatFinishStep && (
                  <button
                    type="button"
                    className="btn btn-primary finish-step"
                    onClick={createGroupAndStart}
                  >
                    {i18n.t("start")}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </ReactModal>
  );
}

export default ChoosePersonsModal;
